export const positiveDecimalToTheHundredthsWithIntegerOrZero = /^(?!-)(^0|([1-9]+\d+)|[1-9])$|(?![\.\,])^(\d?|[1-9]+\d*)[\.\,]\d{1,2}$/;
export const positiveIntegerOrZero = /^(?!-)(^0|([1-9]+\d+)|[1-9])$/;
export const claimValue = /^(?!(0))\d{1,7}$|^(?!(0))\d{1,7}\.\d{1,2}$/;
export const inputPattern = /^-?(?!0\d)(\d{1,7}$|^\d{1,7}[,.]\d{0,2}$)/g;
export const email = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const telephoneWithPolandPrefix = /^\+48\d{9}$/;
